import { leMagService } from "../LeMagService";

export interface ArticleDetailsResponse {
  title: string;
  poster: string;
  slug: string;
  game_id: string[];
  intro: string;
  content: string;
  subtitle: string;
}

export const getArticleDetails = (slug: string) => {
  return leMagService.get<ArticleDetailsResponse>({
    path: `article?slug=${slug}&type=txt`,
  });
};
